
export const getGuestExperienceEnabled = (whiteLabel) =>
    whiteLabel?.subscriber_group?.enable_guest_experience === true;

export const getCandyBarEnabled = (whiteLabel) =>
    whiteLabel?.candy_bar_items === true;

export const getSiteTheme = (whiteLabel) =>
    whiteLabel?.site_theme ?? 1;

export const getReferralCodeEnabled = (whiteLabel) =>
    whiteLabel?.referral_code_flag === true;

export const getReferralPlaceholder = (whiteLabel) =>
    whiteLabel?.referral_placeholder_text ?? "Enter Referral Code";

export const PAYMENT_GATEWAY_EWAY = "eway";
export const PAYMENT_GATEWAY_STRIPE = "stripe";

// Per-group gateway toggle set in Admin > White Label. Defaults to Eway.
export const getPaymentGateway = (whiteLabel) =>
    whiteLabel?.payment_gateway ?? PAYMENT_GATEWAY_EWAY;

export const getStripeEnabled = (whiteLabel) =>
    getPaymentGateway(whiteLabel) === PAYMENT_GATEWAY_STRIPE;

export const getStripePublicKey = (whiteLabel) =>
    whiteLabel?.stripe_public_key ?? null;

